import {makeStyles} from "@material-ui/styles";

export default makeStyles(theme => {
    return {
        root: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            "& svg": {
                width: "30vw",
                height: "30vw",
                fill: theme.palette.success.main
            }
        }
    }
})